module.exports = __webpack_public_path__ + "media/soundtrack.9f6b4e1b.mp3";